import { render, staticRenderFns } from "./NaoSeAplica.vue?vue&type=template&id=d567f2dc"
import script from "./NaoSeAplica.vue?vue&type=script&lang=js"
export * from "./NaoSeAplica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports